<template>
  <div class="card shadow rounded" :class="calcClass" dir="rtl">
    <CookDishCardHeaderComponent :dish="dish"/>
    <DealInfoComponent :dish="dish" v-if="dish.about.deal" menuView/>
    <div v-else>
      <DishInfoComponent :dish="dish" v-on:portion-selected="handlePortionSelected" :previewMode="false"/>
      
      <div class="d-flex text-center f14-l19 justify-content-between align-items-center pointer strong margin-left-right-20" dir="rtl" @click="showDish()">
        <span class="tf11-l13">{{ dish.sections.availability.availability_line }}</span>
        <!-- <a :href="dish.url_title" class="d-flex text-center f14-l19 justify-content-center align-items-center pointer strong" dir="rtl" /> -->
        <span class="red-text tf13-l13 ">{{dish.price_options.labels.order_text}}</span>
      </div>
    </div>
    <HorizontalSplitter />
    <!-- <div v-if="dish.about.deal" class="d-flex flex-row f14-l19 margin-20 pointer" dir="rtl">
      <div class="flex-fill d-flex flex-column">
        <div v-if="dish.sections.availability" v-html="dish.sections.availability.availability_line"></div>
        <div v-if="dish.sections.availability" v-html="dish.sections.availability.min_order"></div>
      </div>
      <div class="d-flex text-start align-items-center pointer" @click="showDish()">
          <span class="red-text ">{{dish.price_options.labels.order_text}}</span>
      </div>
    </div> -->
    <div style="height:60px;padding: 20px" class="d-flex flex-row justify-content-center align-items-center user-select-none">
      <div v-if="!dish.about.deal" class="d-flex flex-row align-items-center addToCartWrapper">
        <div ref="btnPlus" class="amountButton pointer" @click="amountPlus(1)">+</div>
        <div class="red" id="amount" style="margin: 0 10px">{{amount}}</div>
        <div ref="btnMinus" class="amountButton pointer" @click="amountPlus(-1)">-</div>
      </div>
      <div v-if="!dish.about.deal" class="d-flex flex-row align-items-center addToCartButton pointer" @click="submitToCart()"> <!-- @click="submitToCart()"> -->
        <div class="white df16-l19-m f16-l14-m pointer" >{{addToCartText}}</div>
        <div class="white flex-grow-1"></div>
        <div class="white df16-l19-m f16-l14-m price-min-width" id="price">
          <PriceComponent :value="price" />
        </div>
      </div>
      <div v-else class="d-flex flex-row align-items-center openDealButton pointer"  @click="showDish()">
        <div class="white df16-l19-m f16-l14-m pointer" >{{addToCartText}}</div>
        <div class="white flex-grow-1"></div>
        <!-- <div class="white f16-l19-m price-min-width" id="price">
          <PriceComponent :value="price" />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import {formSubmit} from '@/modules/configuration.js';
import {openCart} from '@/modules/utils.js';
import CookDishCardHeaderComponent from "@/components/CookDishCardHeaderComponent.vue";
import DishInfoComponent from "@/components/DishInfoComponent.vue";
import DealInfoComponent from "@/components/DealInfoComponent.vue";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue";
import PriceComponent from "@/components/generic/PriceComponent.vue";
export default {
  components: {
    // DishPreferenceComponent,
    HorizontalSplitter,
    CookDishCardHeaderComponent,
    DishInfoComponent,
    DealInfoComponent,
    PriceComponent,
  },
  props: {
    dish: {}
  },
  data() {
    return {
      amount: 0,
      selectedPortion: {},
    }
  },
  computed: {
    calcClass() {
      if (this.dish?.search_values?.length > 0) {
        return 'filter-elm-' + this.dish.search_values.join(", filter-elm-")
      }
      return 'filter-elm-0';
    },
    price() {
      return parseFloat(this.amount * (this.getSelectedPortion()?.unit_price || 0)).toFixed(2);
    },
    addToCartText() {
      return this.getSelectedPortion()?.action_btn?.label;
    },
    showSelectCity() {
      return this.$store.state.selectCityOpen;
    },


  },
  mounted () {
    let data = this.dish;
    if (!data.about.deal) {
      this.selectedPortion = data?.price_options?.portions[0]?.portion || {};
      this.amount = this.selectedPortion.min || 1;
    }
  },
  unmounted() {
    this.emitter.off("city-selected");
  },

  methods: {
    showDish() {
      this.$router.push(this.dish.url);
      // this.$store.dispatch('fetchDish', this.dish.url);
      // let offcanvas = document.getElementById("offcanvasExample");
      // var bsOffcanvas = new bootstrap.Offcanvas(offcanvas);
      // bsOffcanvas.show();
    },
    showCook() {
      this.$router.push(this.dish.sections.cook_info.title.href);
    },
    enableDisableButtons() {
      const btnPlus = this.$refs.btnPlus;
      const btnMinus = this.$refs.btnMinus;
      const selected = this.getSelectedPortion();
      if (this.amount == selected.min) {
        btnMinus.classList.add('disabled');
      } else {
        btnMinus.classList.remove('disabled');
      }
      if (this.amount == selected.max) {
        btnPlus.classList.add('disabled');
      } else {
        btnPlus.classList.remove('disabled');
      }
    },
    amountPlus(toAdd) {
      let selected = this.getSelectedPortion();
      let amount = this.amount + (toAdd || 0);
      if (amount < (selected.min || 1)) amount = (selected.min || 1);
      if (amount > (selected.max || 10)) amount = (selected.max || 10);
      this.amount = amount;
      this.enableDisableButtons();
    },
    changeAmountToMin() {
      let selected = this.getSelectedPortion();
      this.amount = (selected.min || 1);
      this.enableDisableButtons();
    },
    handlePortionSelected(portion) {
      this.selectedPortion = portion;
      this.changeAmountToMin();
    },
    getSelectedPortion() {
      if (this.selectedPortion?.unit_price) return this.selectedPortion;
      if (this.dish?.price_options) return this.dish.price_options.portions[0].portion;
      return null;
    },
    async submitToCart() {
      let response = await formSubmit(this, null, this.getSelectedPortion().action_btn.url + "&amount=" + this.amount);
      openCart(this,response);
      this.emitter.on("city-selected", () => {
        this.submitToCart();
      });
      // if (this.$isDesktop(true) && response?.cart?.url) {
      //   this.$emit('close');
      //   this.$store.dispatch('showPopupWithUrl', response.cart.url);
      // } else if (response.popup_content || response?.prompt_json?.popup_content) {
      //   this.$store.dispatch('showPopup', response.popup_content || response?.prompt_json?.popup_content);
      // }
    },
    openSelectCity() {
      this.IFired = true;
      this.$store.dispatch('showSelectCity');
    }

  },
}
</script>
<style scoped>
  .addToCartWrapper {
    height: 35px;
    background-color: #ffcfd2;
    border-radius: 0 30px 30px 0;
    padding: 10px 15px 10px 10px;
  }

  .addToCartButton {
    height: 35px;
    background-color: #ef3d49;
    border-radius: 30px 0 0 30px;
    padding: 10px 5px 10px 15px;
  }

  .openDealButton {
    height: 35px;
    background-color: #ef3d49;
    border-radius: 30px 30px 30px 30px;
    padding: 10px 30px 10px 30px;
  }

  .amountButton {
    background-color: white;
    border-radius: 15px;
    height: 30px;
    width: 30px;
    text-align: center;
    color: red;
    font-size: 24px;
    line-height: 24px;
  }

  .amountButton.disabled {
    background-color: #eee;
    color: white;
  }

  .margin-left-right-20 {
    margin-left: 20px; 
    margin-right: 20px;
  }
</style>